import React from 'react';
import TextInput from '../../components/form/TextInput';

export default class TreinoAcademia extends React.Component{
  render(){
    const data = this.props.data;
    const strings = this.props.strings;
    const exercicios = this.props.getExercicios();
    const obs = data.observacoes ? (<div className='obs-box'>
      <span  className='obs-box__title'>{strings.observacoes}</span>
      <div className='obs-box__text'>{data.observacoes}</div>
    </div>) : null;
    return(
      <div>
        <div className="pure-u-1 pure-u-md-8-24">
          <TextInput
            type='text'
            value={data.cadencia}
            title={`${strings.txtCadencia}`}
            readOnly
          />
        </div>
        <div className="pure-u-1  pure-u-md-8-24">
          <TextInput
            type='text'
            value={data.intervalo}
            title={`${strings.txtIntervalo}`}
            readOnly
          />
        </div>
        <div className="pure-u-1 pure-u-md-8-24">
          <TextInput
            type='text'
            value={data.repeticoes}
            title={`${strings.txtRepeticoes}`}
            readOnly
          />
        </div>
        {obs}
        <span className='separator'></span>
        {exercicios}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/treino/TreinoAcademia.js